const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

const controller = '/v1/chronique';

export const ScheduleGroupsQuery: any = {
    GetScheduleGroups: Backofficebff + controller + '/list-of-schedule-groups',
    GetScheduleGroupUsers: Backofficebff + controller + '/list-of-schedule-group-user-by-groupId',
};
